import { uploadItemImages } from 'api/services/item';

export class ImageUploadHelper {
  private photos: (string | File)[];
  private featuredPhoto: string;
  constructor(photos: (string | File)[], featuredPhoto: string) {
    this.photos = photos;
    this.featuredPhoto = featuredPhoto;
  }

  private setFeaturedImage = (data: string) => {
    this.featuredPhoto = data;
  };

  private segregatePhotos = () => {
    const photoList = [...this.photos];
    const oldPhotos = [];
    const newPhotos = [];
    let featuredPhoto = null;

    const base64ToFile = (
      base64Data: string,
      fileName: string,
      mimeType: string,
    ): File => {
      const byteString = atob(base64Data);
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
      }
      return new File([byteArray], fileName, { type: mimeType });
    };

    for (let i = 0; i < photoList.length; i++) {
      const element = photoList[i];
      const isBase64 =
        typeof element === 'string' && element.includes('data:image');
      const fileName = typeof element === 'string' ? element : element.name;
      const isFeaturedPhoto = this.featuredPhoto === fileName;

      if (isFeaturedPhoto) {
        if (isBase64) {
          const base64 = element.split(',')[1];
          const mimeType = element.split(';')[0].split(':')[1];
          const extension = mimeType.split('/')[1];
          const newFileName = `image-${Date.now()}.${extension}`;
          featuredPhoto = base64ToFile(base64, newFileName, mimeType);
        } else {
          featuredPhoto = element;
        }
      }

      if (!isFeaturedPhoto) {
        if (typeof element === 'string') {
          if (isBase64) {
            const base64 = element.split(',')[1];
            const mimeType = element.split(';')[0].split(':')[1];
            const extension = mimeType.split('/')[1];
            const newFileName = `image-${Date.now()}.${extension}`;
            const file = base64ToFile(base64, newFileName, mimeType);
            newPhotos.push(file);
          } else {
            oldPhotos.push(element);
          }
        } else {
          newPhotos.push(element);
        }
      }
    }

    return {
      newPhotos,
      oldPhotos,
      featuredPhoto,
    };
  };

  async upload(): Promise<UploadResponse | null> {
    try {
      const data = this.segregatePhotos();

      const uploadImages = await uploadItemImages(data.newPhotos as File[]);

      const featuredImagesToUpload =
        typeof data.featuredPhoto !== 'string' ? [data.featuredPhoto] : [];

      const uploadfeaturedPhoto = await uploadItemImages(
        featuredImagesToUpload as File[],
      );

      if (uploadfeaturedPhoto.length > 0) {
        data.featuredPhoto = uploadfeaturedPhoto[0];
      }

      const photosWithoutFeatured = data.oldPhotos
        .concat(uploadImages)
        .filter((photo) => photo !== data.featuredPhoto);

      return Promise.resolve({
        photos: photosWithoutFeatured,
        featuredPhoto: data.featuredPhoto,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }

  validate(onFailed: (message: string) => void) {
    if (this.photos.length < 3) {
      onFailed('Please select at least 3 photos');
      return false;
    } else {
      if (this.featuredPhoto === '') {
        onFailed('Please select featured image');
        return false;
      }
    }
    return true;
  }
}

type UploadResponse = {
  photos: any[];
  featuredPhoto: any;
};
